module.exports = __webpack_public_path__ + "img/logol.0e4d354a.png";